import React from "react";

// Progress bar for limited-quantity offers. Fills up as coupons are claimed.
export default function StockBar({ quantity, remaining, variant = "card" }) {
  if (!quantity || remaining === null || remaining === undefined) return null;
  const rem = Math.max(0, Math.min(quantity, remaining));
  const claimed = quantity - rem;
  const pct = Math.max(0, Math.min(100, Math.round((claimed / quantity) * 100)));
  const low = rem <= Math.max(3, Math.ceil(quantity * 0.2));
  const soldOut = rem <= 0;
  const fill = soldOut ? "bg-slate-400" : low ? "bg-[#E63946]" : "bg-emerald-500";

  if (variant === "detail") {
    return (
      <div data-testid="stock-bar" className="space-y-1.5">
        <div className="flex items-center justify-between text-sm font-bold">
          <span className={soldOut ? "text-slate-500" : low ? "text-[#E63946]" : "text-slate-700"}>
            {soldOut ? "Esaurito" : low ? "Quasi esaurito!" : "Disponibilità"}
          </span>
          <span className="text-slate-500">{rem} di {quantity} rimasti</span>
        </div>
        <div className="h-2.5 w-full rounded-full bg-slate-100 overflow-hidden">
          <div className={`h-full rounded-full ${fill} transition-[width] duration-700 ease-out`} style={{ width: `${pct}%` }} />
        </div>
      </div>
    );
  }

  return (
    <div data-testid="stock-bar" className="mt-2">
      <div className="flex items-center justify-between mb-1">
        <span className={`text-[11px] font-bold ${soldOut ? "text-slate-400" : low ? "text-[#E63946]" : "text-slate-500"}`}>
          {soldOut ? "Esaurito" : low ? "Quasi esaurito!" : `${rem} rimasti`}
        </span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-slate-100 overflow-hidden">
        <div className={`h-full rounded-full ${fill} transition-[width] duration-700 ease-out`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
